import { Component, OnInit, Input } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { BaseService } from '../../shared-service/base.service';
import { SuggestionsService } from './suggestions.service';
import { WindowRef } from '../../shared-service/windowRef.service';

declare var jquery: any;
declare var $: any;

@Component({
	selector: 'app-suggestions',
	templateUrl: './suggestions.component.html',
	styleUrls: ['./suggestions.component.css']
})

export class SuggestionsComponent implements OnInit {

	@Input() public suggestions: {data:Array<any>} = {data:[]};

	constructor(private router: Router, public bs: BaseService, public suggest: SuggestionsService, private route: ActivatedRoute,private winRef:WindowRef) {
		
	}

	ngOnInit() {
		let suggNode:any = this.winRef.nativeWindow.document.getElementById("showSuggestion").className;
		this.winRef.nativeWindow.document.getElementById("showSuggestion").className = suggNode + " show";
		this.initializeCrowsel();
	}

	initializeCrowsel() {
		setTimeout(() => {
			$('.H_carousel').owlCarousel({
				autoplay: false,
				rewind: false,
				margin: 20,
				mergeFit: true,
				rtl: this.bs.getUserAttr("Culture") == 'ar-AE' ? true : false,
				responsiveClass: true,
				autoHeight: true,
				smartSpeed: 800,
				nav: true,
				navText: ['<span class="fa fa-angle-left" aria-hidden="true"></span>',
					'<span class="fa fa-angle-right" aria-hidden="true"></span>'],
				responsive: {
					0: {
						items: 2
					},
					600: {
						items: 2
					},
					768: {
						items: 3,
						margin: 105
					},
					992: {
						items: 3,
						margin: 105
					},
					1024: {
						items: 3,
						margin: 105
					},
					1366: {
						items: 4
					}
				}
			});
			$(".owl-slider").css("display", "block");
			$(".H_carousel .owl-nav .owl-next").css("display", "block");
		}, 1000);
	}

	OpenItem(item:any) {
		this.bs.setCurrentModulePath(this.bs.loadModulePath('tsk_mdl'));
		let params = {
			tab: '',
			id: item.CourseId
		}

		if (item.hasOwnProperty('ItemTypeCode')) {
			if (item['IsAssigned']) {
				if (item['ItemTypeCode'] == 'C')
					this.navigateToCoursePage(params);
				else
					this.navigateToILTPage(params);
			}
			else {
				if (item['ItemTypeCode'] == 'C') {
					if (item['IsAccessed'])
						this.navigateToCoursePage(params);
					else
						this.navigateToCourseCatalog(params);
				}
				else {
					if (item['IsAccessed'])
						this.navigateToILTPage(params);
					else
						this.navigateToILTCatalog(params, '');
				}
			}
		}
		else {
			this.navigateToCourseCatalog(params)
		}
	}

	navigateToCourseCatalog(params:any) {
		this.bs.activateMenuItem('M');
		this.router.navigate(['/learner/taskList/container/catalog-detail', params], { relativeTo: this.route.parent });
	}

	navigateToCoursePage(params:any) {
		this.bs.activateMenuItem('M');
		params['CourseLaunchId'] = '';
		params['IsNodeClick'] = false;
		this.bs.isResumeClicked = true;
		this.routeTo(this.bs.loadModulePath('tsk_mdl') + this.bs.getDirectPath('crs_dtl'), params);
	}

	navigateToILTCatalog(params:any, cnsData:any) {
		this.bs.activateMenuItem('M');
		params['cns'] = cnsData;
		this.router.navigate(['/learner/taskList/container/catalog-ilt-detail', params], { relativeTo: this.route.parent });
	}

	navigateToILTPage(params:any) {
		this.bs.activateMenuItem('M');
		this.bs.routerParam['ILT_DETAIL'] = params;
		this.routeTo(this.bs.loadModulePath('tsk_mdl') + this.bs.getDirectPath('ilt_dtl'), params);
	}

	routeTo(path: string, params: object) {
		this.router.navigate([path, params]).then((res) => {
			console.log(res);
		});
	}
}
